module.exports = __webpack_public_path__ + "static/media/image.493c2c1d.svg";